import React from 'react';
import { motion, AnimatePresence, useScroll, useTransform } from 'motion/react';
import { useLocation } from 'react-router-dom';
import CharcoalBG from '../assets/charcoal-bed.webp'

interface SliceTransitionProps {
  children: React.ReactNode;
}

const SliceTransition: React.FC<SliceTransitionProps> = ({ children }) => {
  const location = useLocation();
  const { scrollYProgress } = useScroll();

  return (
    <div style={{ position: 'relative', width: '100%', minHeight: '100vh' }}>
      <AnimatePresence mode="sync">
        <motion.div
          key={location.pathname}
          initial={{ 
            opacity: 0,
            scale: 0.95
          }}
          animate={{ 
            opacity: 1,
            scale: 1,
            transition: {
              duration: 0.6,
              ease: [0.4, 0.0, 0.2, 1]
            }
          }}
          exit={{
            opacity: 0,
            scale: 0.95,
            transition: {
              duration: 0.3,
              ease: [0.4, 0.0, 0.2, 1]
            }
          }}
          style={{
            position: 'relative',
            width: '100%',
            minHeight: '100vh',
            overflowX:'clip'

          }}
        >
          <motion.div
            // style={{
            //   position: 'fixed',
            //   width: '100%',
            //   height: '100vh',
            //   backgroundImage: `url(${CharcoalBG})`,
            //   backgroundSize: "cover",
            //   backgroundPosition: "center",
            //   filter:'grayscale(1) brightness(.5)',
            //   zIndex: -1,
            //   top: '0px',
             
            //  // maskSize: '100% 100%'
            // }}
         
          >

          </motion.div>
          {children}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default SliceTransition; 